const middleware = {}

middleware['i18n'] = require('../middleware/i18n.js')
middleware['i18n'] = middleware['i18n'].default || middleware['i18n']

middleware['site'] = require('../middleware/site.js')
middleware['site'] = middleware['site'].default || middleware['site']

export default middleware
